module.exports = __webpack_public_path__ + "img/news_brief_2.00e36711.png";